import { render } from "./Clock.vue?vue&type=template&id=2b118a77&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=2b118a77&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b118a77"]])

export default __exports__